// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React, {useContext} from 'react';
import {ThemeProvider} from '@material-ui/core';
import {createTheme as createMuiTheme} from '@material-ui/core/styles';
import {DatePicker} from '@material-ui/pickers';
import moment, {Moment} from 'moment';

import './DateRange.scss';
import {StoreContext} from '@app/state';
import {connect} from 'react-redux';
import {
    changeSelectedMaxDate,
    changeSelectedMinDate,
} from '@app/redux/application/actions';

interface IDateRangeProps {
    minDate?: any;
    setMinDate?: any;
    maxDate?: any;
    setMaxDate?: any;
    dispatchMinDate?: any;
    dispatchMaxDate?: any;
}

const theme = createMuiTheme({
    overrides: {
        //@ts-ignore
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#3A1C95',
            },
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: '#6C3DFF',
                '&:hover': {
                    backgroundColor: '#2A1173',
                },
            },
        },
        MuiButton: {
            textPrimary: {
                color: '#FFFFFF',
                backgroundColor: '#6C3DFF',
                fontFamily: "'Inter', 'Roboto Mono', arial, sans-serif",
                fontSize: 12,
                '&:hover': {
                    backgroundColor: '#2A1173',
                },
            },
        },
    },
});
const todayAtNight = moment();
todayAtNight.endOf('day');
const DateRangeComponent = (props: IDateRangeProps) => {
    const {dispatchMinDate, dispatchMaxDate} = props;

    const setDateValues = () => {
        if (
            props.minDate &&
            props.setMinDate &&
            props.maxDate &&
            props.setMaxDate
        ) {
            return props;
        } else {
            const d = useContext(StoreContext).date;
            dispatchMinDate(d.minDate);
            dispatchMaxDate(d.maxDate);
            return d;
        }
    };

    const {minDate, setMinDate, maxDate, setMaxDate} = setDateValues();
    return (
        <div className="DateRange__container">
            <ThemeProvider theme={theme}>
                <span className="DateRange__subtitle">From</span>
                <DatePicker
                    disableFuture
                    openTo="year"
                    format="DD/MM/YYYY"
                    views={['date']}
                    maxDate={maxDate}
                    value={minDate}
                    onChange={(d) => {
                        setMinDate(d);
                        dispatchMinDate(d);
                    }}
                />
                <span className="DateRange__subtitle">To</span>
                <DatePicker
                    maxDate={todayAtNight}
                    openTo="year"
                    format="DD/MM/YYYY"
                    views={['date']}
                    minDate={minDate}
                    value={maxDate}
                    onChange={(d) => {
                        setMaxDate(d);
                        dispatchMaxDate(d);
                    }}
                />
            </ThemeProvider>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchMinDate: (minDate: Moment) =>
            dispatch(changeSelectedMinDate(minDate)),
        dispatchMaxDate: (maxDate: Moment) =>
            dispatch(changeSelectedMaxDate(maxDate)),
    };
};

export const DateRange = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DateRangeComponent as any);
